import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

var _queryMap;

/**
 * @module grand-whitelisted-hashes
 * @ignore
 * __VERSION_HERE__
 * */

/**
 * used in ux-tread-cart-redux
 * Current version
 *
 * @returns {string}
 */
export var designViewsByIds = '6f31f844ad6d7376f4f0db255dde4545';
export var getCartTotalsForPaypal = 'b96aa9e5efa9d26e283480fe6a2fb848';
/**
 * getPaginatedItemsWithProducts
 *
 * @description plural query hash for fetching products, thread or design view product info
 * Previous version: v11 - f8a145811909db48272c5852a89535a2
 * Current version: v12 - ac7455674e07d6a56bdb69319c0b1739
 * @returns {string}
 */

export var getPaginatedItemsWithProducts = 'ac7455674e07d6a56bdb69319c0b1739';
/**
 * getPaginatedItemsWithPrices
 *
 * @description plural query hash for fetching products, thread or design view product info
 * Previous version: v4 - 6bdf89422aa0188330c1bc92c7a9550f
 * Current version: v5 - 9dfb3501982eb72202ed05daf77d5566
 * @returns {string}
 */

export var getPaginatedItemsWithPrices = '9dfb3501982eb72202ed05daf77d5566';
/**
 * getSkuAndDesignViewById
 *
 * @description singular query hash for fetching sku or design view product info
 * Current version
 * @returns {string}
 */

export var getSkuAndDesignViewById = 'a787877f5cfcae2008f7a445efa08f4b';
/**
 * getSkusAndDesignViewsByIds
 *
 * @description plural query hash for fetching sku or design view product info
 * Previous version: v12 - e8efb909a661cc60f21f7da93fb48815
 * Current version: v13 - f579b3215d5a7fe5a90a8060fe6bf873
 * @returns {string}
 */

export var getSkusAndDesignViewsByIds = 'f579b3215d5a7fe5a90a8060fe6bf873';
/**
 * getSkuPriceAndAvailability
 *
 * @description singular query hash for fetching sku price and availability
 * @returns {string}
 */

export var getSkuPriceAndAvailability = '20bc04f9cc08b04152c2533176d3d787';
/**
 * getSkusPriceAndAvailability
 *
 * @description plural query hash for fetching sku price and availability
 * @returns {string}
 */

export var getSkusPriceAndAvailability = 'ef571ff0ac422b0de43ab798cc8ff25f';
/**
 * getWishlistItemsWithProducts
 *
 * @description plural query hash for fetching products, thread or design view product info
 * Previous version: v11 - 0d91589c2a745b0a6bdda26d256ae4cd
 * Current version: v12 - 72b1f069bcf1ddcb2b7e6cc5f4063d4c
 * @returns {string}
 */

export var getWishlistItemsWithProducts = '72b1f069bcf1ddcb2b7e6cc5f4063d4c';
/**
 * getShippingOptionsCartReviewsWithVasContent
 * Previous version: v3 - 94fbad0387617af78ca45701e9aeb902
 * Current version: v4 - 04208603cbdb95cfc1f29fcc96fcacef
 *
 * @returns {string}
 */

export var getShippingOptionsCartReviewsWithVasContent = '04208603cbdb95cfc1f29fcc96fcacef';
/**
 * postPaymentOptions
 *
 * @description singular query hash for fetching available payment options for country, billing country, and currency
 * @returns {string}
 */

export var postPaymentOptions = 'd9963355aaff5ed961aa7ebfe7502356';
/**
 * getFulfillmentOfferingsAndCartReviews
 * Previous version: v4 - 8739fb4d58439e183cfacd038c41cea0
 * Current version: v5 - 9d588037b53acb1c51e79572e8329e1d
 *
 * @returns {string}
 */

export var getFulfillmentOfferingsAndCartReviews = '9d588037b53acb1c51e79572e8329e1d';
/**
 * getFulfillmentOfferings
 * Previous version: v1 - e936d0b35318cc8c15563ed0513b2205
 * Current version: v2 - c38220e778b4320a168d79e781d63cde
 *
 * @returns {string}
 */

export var getFulfillmentOfferings = 'c38220e778b4320a168d79e781d63cde';
/**
 * getPaypalExpressURL
 * Current version: v1: - 99a90cdb348664bccf0903a6ca198628
 *
 * @returns {string}
 */

export var getPaypalExpressURL = '99a90cdb348664bccf0903a6ca198628';
/**
 * getFulfillmentOfferingsAndPartnerCartReviews
 * Previous version: v2: - 594f9e30500abff297d339b698eb91e5
 * Current version: v3: - 3443c8b808257efc2bdb42114b508d38
 * Note: the v1 version may be confusing. The "v2" of in the query name is from the API version, NOT the hash
 *
 * @returns {string}
 */

export var getFulfillmentOfferingsAndPartnerCartReviews = '3443c8b808257efc2bdb42114b508d38'; // ^  NOTE noone called out there is no foff + partnerCartReviewsV1? or are we planning to?

/**
 * getPartnercartPreorder
 * Previous version: v1: - e56d2862bccb9d691fadbb364c40872d
 * Current version: v2: - 12effcc381ebcd6cd0e60bc585a010b5
 *
 * @returns {string}
 */

export var getPartnercartPreorder = '12effcc381ebcd6cd0e60bc585a010b5';
/**
 * getFulfillmentTypesOfferingsAndCartReviews
 * Current version: v1: - 594f9e30500abff297d339b698eb91e5
 *
 * @returns {string}
 */

export var getFulfillmentTypesOfferingsAndCartReviews = '7a1edde9cc7a108f5aa80b259ec4e6a9';
/**
 * getFulfillmentTypesOfferings
 * Current version: v1: - 594f9e30500abff297d339b698eb91e5
 *
 * @returns {string}
 */

export var getFulfillmentTypesOfferings = '976f5651fd7eb519e839b38567864dca';
/**
 * getFulfillmentTypesOfferingsAndPartnerCartReviews
 * Previous version: v1: - 1fb62005eda6074c3e26502e7f102f10
 * Current version: v2: - eb3077f19d3357079804cf793595f627
 *
 * @returns {string}
 */

export var getFulfillmentTypesOfferingsAndPartnerCartReviews = 'eb3077f19d3357079804cf793595f627';
export var queryMap = (_queryMap = {}, _defineProperty(_queryMap, designViewsByIds, 'getskudesignviewids/v1'), _defineProperty(_queryMap, getCartTotalsForPaypal, 'getcarttotalsforpaypal/v1'), _defineProperty(_queryMap, getFulfillmentOfferingsAndCartReviews, 'getfulfillmentofferingsandcartreviews/v5'), _defineProperty(_queryMap, getFulfillmentOfferingsAndPartnerCartReviews, 'getfulfillmentofferingsandpartnercartreviews/v3'), _defineProperty(_queryMap, getFulfillmentOfferings, 'getfulfillmentofferings/v2'), _defineProperty(_queryMap, getFulfillmentTypesOfferingsAndCartReviews, 'getfulfillmenttypesofferingsandcartreviews/v1'), _defineProperty(_queryMap, getFulfillmentTypesOfferingsAndPartnerCartReviews, 'getfulfillmenttypesofferingsandpartnercartreviews/v2'), _defineProperty(_queryMap, getFulfillmentTypesOfferings, 'getfulfillmenttypesofferings/v1'), _defineProperty(_queryMap, getPaginatedItemsWithPrices, 'getpaginateditemswithprices/v5'), _defineProperty(_queryMap, getPaginatedItemsWithProducts, 'getpaginateditemswithproducts/v12'), _defineProperty(_queryMap, getPaypalExpressURL, 'getpaypalexpressurl/v1'), _defineProperty(_queryMap, getShippingOptionsCartReviewsWithVasContent, 'getshippingoptionscartreviewswithvascontent/v4'), _defineProperty(_queryMap, getSkuPriceAndAvailability, 'getskupriceandavailability/v1'), _defineProperty(_queryMap, getSkusAndDesignViewsByIds, 'getskusanddesignviewsproductinfo/v13'), _defineProperty(_queryMap, getSkusPriceAndAvailability, 'getskuspriceandavailability/v2'), _defineProperty(_queryMap, getWishlistItemsWithProducts, 'getwishlistitemswithproducts/v12'), _defineProperty(_queryMap, postPaymentOptions, 'postpaymentoptions/v1'), _queryMap);